import React, {useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { Box, 
  Typography,
  Toolbar,
  FormControl,
  MenuItem,
  Select
} from '@mui/material';

const WelcomePage = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = useCallback((lng) => {
    i18n.changeLanguage(lng);
  }, [i18n]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '68px',
          borderBottom: '1px solid #e0e0e0',
          zIndex: 10,
          bgcolor: 'background.paper',
        }}
      >
        <Toolbar
          sx={{
            px: { md: 6, xl: 2},
          }}
        >
          <Typography variant='h2' component='h2' sx={{ flexGrow: 1 }}>
            {t('welcome.title')}
          </Typography>

          {/* Language Selector Dropdown */}
          <FormControl size='small' sx={{ minWidth: 100, mr: 2 }}>
            <Select
              value={i18n.language}
              onChange={(e) => changeLanguage(e.target.value)}
              variant='standard'
              disableUnderline
              sx={{
                '& .MuiSelect-select': {
                  paddingBottom: 0,
                  fontSize: 14,
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: 300,
                  },
                },
              }}
            >
              <MenuItem value='en'>{t('languages.en')}</MenuItem>
              <MenuItem value='de'>{t('languages.de')}</MenuItem>
            </Select>
          </FormControl>

          {/* <IconButton aria-label='theme'>
            <Brightness4Icon />
          </IconButton> */}
        </Toolbar>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
        }}
      >
        {/* <Typography variant="h4" component="div"> */}
        <Typography variant="h2" sx={{ mt: 4, whiteSpace: 'pre-line', textAlign: 'center' }}>
          {t('welcome.text')}
        </Typography>
      </Box>
    </Box>
  );
}

export default WelcomePage; 